class CollapsibleContent extends HTMLElement {
  constructor() {
    super();

    /** @type HTMLDetailsElement */
    this.detailsEl = this.querySelector("details");
    /** @type HTMLElement */
    this.summaryEl = this.querySelector("summary");
    /** @type HTMLElement */
    this.contentEl = this.querySelector("details > div");

    // This will make a return when i have time.
    // this.summaryEl.addEventListener("click", (e) => {
    //   if (!this.detailsEl.open)
    //     return (this.contentEl.style.maxHeight = "var(--content-height)");
    //   e.preventDefault();
    //   this.contentEl.style.maxHeight = "0px";
    //   setTimeout(() => {
    //     this.detailsEl.removeAttribute("open");
    //   }, 250);
    // });
  }

  connectedCallback() {
    // this.detailsEl.setAttribute("open", "open");
    // const contentHeight = this.contentEl.offsetHeight;
    // this.detailsEl.style = `--content-height:${contentHeight}px`;
    // this.detailsEl.removeAttribute("open");
    // this.contentEl.style.maxHeight = "0px";
  }

  openCollapsible() {
    this.detailsEl.add;
  }
}

customElements.define("collapsible-content", CollapsibleContent);
